import React, { useState, useEffect } from "react";
import Request from "./RequestTableItem";

function RequestTable({
  selectedItems,
  handleSelectedItems,
  isFetching,
  requests,
  confirmBtn,
}) {
  return (
    <div className="bg-white shadow-lg rounded-sm border border-slate-200 relative">
      <div>
        {/* Table */}
        <div className="overflow-x-auto">
          <table className="table-auto w-full">
            {/* Table header */}
            <thead className="text-xs font-semibold uppercase text-slate-500 bg-slate-50 border-slate-200">
              <tr>
                {/* <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
                  <div className="flex items-center">
                    <label className="inline-flex">
                      <span className="sr-only">Select all</span>
                      <input
                        className="form-checkbox"
                        type="checkbox"
                        onChange={handleSelectAll}
                      />
                    </label>
                  </div>
                </th> */}
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold text-left">Created At</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold text-left">Title</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold text-left">Type</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold text-left">Status</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <span className="sr-only">Menu</span>
                </th>
              </tr>
            </thead>
            {/* Table body */}
            <tbody className="table-auto text-sm divide-y divide-slate-200">
              {requests.map((request) => {
                return (
                  <Request
                    request={request}
                    handleClick={() => handleSelectedItems(request.id)}
                    isChecked={selectedItems.includes(request.id)}
                    confirmBtn={confirmBtn}
                  />
                );
              })}
              {!isFetching && requests.length === 0 && (
                <tr>
                  <td colSpan="6">
                    <div className="col-span-12 flex items-center justify-center py-5 text-xl">
                      {/* Show Empty */}
                      No Found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default RequestTable;
